<script>
/**
 * Estado vazio padronizado ("nenhum registro por aqui").
 *
 * Antes cada tela resolvia isso do seu jeito: umas com skeleton, outras com
 * uma linha de texto solta em cinza, outras com nada. Este componente e a
 * contraparte Vue das classes .empty-state de
 * src/design/custom/components/_empty-state.scss.
 *
 * Uso:
 *   <EmptyState
 *     icon="bx bx-user-plus"
 *     title="Nenhum lead indicado ainda"
 *     text="Compartilhe seu link de indicação para começar."
 *   >
 *     <template #action>
 *       <b-button variant="default">Copiar link</b-button>
 *     </template>
 *   </EmptyState>
 */
export default {
  name: "EmptyState",
  props: {
    icon: {
      type: String,
      default: "bx bx-folder-open",
    },
    title: {
      type: String,
      default: "Nada por aqui ainda",
    },
    text: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "md",
      validator: (value) => ["sm", "md"].indexOf(value) !== -1,
    },
  },
};
</script>

<template>
  <div class="empty-state" :class="{ 'empty-state-sm': size === 'sm' }" role="status">
    <div class="empty-state-icon" aria-hidden="true">
      <slot name="icon">
        <i :class="icon"></i>
      </slot>
    </div>
    <h5 class="empty-state-title">{{ title }}</h5>
    <p v-if="text" class="empty-state-text">{{ text }}</p>
    <div v-if="$slots.action" class="empty-state-action">
      <slot name="action"></slot>
    </div>
  </div>
</template>
